/**
 * The ERS bands the calculator offers, mirroring the merchant dashboard's table so a quote
 * taken in either place starts from the same rating.
 *
 * Each tile sends its `minErs` as the exact ERS — the worst score in the band, so the estimate
 * is the conservative end of what the band would be given. The rate itself is never derived
 * here: the credit engine resolves it from that score (rate agreement, iFinance promotion,
 * norms tier, merchant rate modifier).
 *
 * The boundaries are the norms-tier floors plus the merchant rate-agreement thresholds (725,
 * 825), so every band lands on a bracket the engine can actually distinguish. 550 is the
 * lowest score the personal loan norms price.
 */
export const CREDIT_RATING_BANDS = [
  { minErs: 850, maxErs: null, nameKey: 'calculator.creditRatingOptions.exceptional' },
  { minErs: 830, maxErs: 850, nameKey: 'calculator.creditRatingOptions.excellent' },
  { minErs: 810, maxErs: 830, nameKey: 'calculator.creditRatingOptions.veryGood' },
  { minErs: 770, maxErs: 810, nameKey: 'calculator.creditRatingOptions.good' },
  { minErs: 720, maxErs: 770, nameKey: 'calculator.creditRatingOptions.aboveAverage' },
  { minErs: 700, maxErs: 720, nameKey: 'calculator.creditRatingOptions.average' },
  { minErs: 665, maxErs: 700, nameKey: 'calculator.creditRatingOptions.fair' },
  { minErs: 635, maxErs: 665, nameKey: 'calculator.creditRatingOptions.building' },
  { minErs: 605, maxErs: 635, nameKey: 'calculator.creditRatingOptions.limited' },
  { minErs: 550, maxErs: 605, nameKey: 'calculator.creditRatingOptions.veryLimited' },
] as const

export type CreditRatingBand = (typeof CREDIT_RATING_BANDS)[number]

/** The top band — the tiles are never left unselected. */
export const DEFAULT_ERS_SCORE: number = CREDIT_RATING_BANDS[0].minErs
